import { buttonStyles, Modal } from '@skupreme/shared/ui';
import { CommonUtility } from '@utility/common';

type TradeTermsModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

function TradeTermsModal({ open, setOpen }: TradeTermsModalProps) {
  return (
    <Modal
      isOpen={open}
      onOpenChange={setOpen}
      size="xl"
      title="Incoterms"
      showCloseButton
      footer={
        <a
          target="_blank"
          href="/trade-terms"
          rel="noopener"
          className={buttonStyles({ variant: 'primary' })}
        >
          See Incoterms
        </a>
      }
    >
      <img
        src={CommonUtility.getCdnLink('homepage/Incoterms.svg')}
        alt="Incoterms chart"
        loading="lazy"
        height={589}
        width={922}
        className="sk:mx-auto sk:block sk:h-auto sk:max-w-full"
      />
    </Modal>
  );
}

export default TradeTermsModal;
